import type { Theme } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

export const LOCALITY_LICENSE_ACTIVITY_ACTIVE = 52
export const LOCALITY_LICENSE_ACTIVITY_INACTIVE = 51

export type LocalityLogEventKind = 'active' | 'inactive' | 'unknown'

export const getLocalityLogEventKind = (activityType: number): LocalityLogEventKind => {
  if (activityType === LOCALITY_LICENSE_ACTIVITY_ACTIVE) return 'active'
  if (activityType === LOCALITY_LICENSE_ACTIVITY_INACTIVE) return 'inactive'
  return 'unknown'
}

export const formatLocalityActivityWhen = (iso: string, locale: string): string => {
  try {
    return new Date(iso).toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' })
  } catch {
    return iso
  }
}

export const getLocalityLogChipColors = (theme: Theme, kind: LocalityLogEventKind) => {
  if (kind === 'active') {
    return {
      bg: getThemeColor(theme, MUIThemeColors.successMain),
      color: getThemeColor(theme, MUIThemeColors.white),
    }
  }
  if (kind === 'inactive') {
    return {
      bg: getThemeColor(theme, MUIThemeColors.warningMain),
      color: getThemeColor(theme, MUIThemeColors.white),
    }
  }
  return {
    bg: getThemeColor(theme, MUIThemeColors.secondaryLight),
    color: getThemeColor(theme, MUIThemeColors.primaryDark),
  }
}

export type LocalityActivityLogChipPresentation = {
  label: string
  backgroundColor: string
  foregroundColor: string
}

export const getLocalityActivityLogChipPresentation = (
  activityType: number,
  translateAdminLicense: (translationKey: string) => string,
  theme: Theme,
): LocalityActivityLogChipPresentation => {
  const eventKind = getLocalityLogEventKind(activityType)
  const label =
    eventKind === 'active'
      ? translateAdminLicense('logEventActive')
      : eventKind === 'inactive'
        ? translateAdminLicense('logEventInactive')
        : translateAdminLicense('logEventUnknown')
  const chipColors = getLocalityLogChipColors(theme, eventKind)
  return {
    label,
    backgroundColor: chipColors.bg,
    foregroundColor: chipColors.color,
  }
}
